var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"suggestions"},[_c('div',{staticClass:"p-col-12 p-md-12 p-lg-12 p-p-3 p-p-lg-0"},[_c('Home'),_c('suggestionsTable',{staticClass:"p-p-2",attrs:{"isRecommendations":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }